import { reactive, ref, getCurrentInstance, computed, defineProps, onMounted } from 'vue';
export const useActionCommonDetail = proxy => {
  const gridInfo = ref({
    selected: [],
    /**
     * Số lượng bản ghi trên 1 trang
     */
    pageSize: 20,
  });

  /**
   * Thay đổi pagesize
   */
  function gridChangePageSize(value) {
    gridInfo.value.pageSize = value;
  }

  function grid() {
    return proxy.$refs['viewList'];
  }

  /**
   * Load lại dữ liệu
   */
  function reload() {
    const me = proxy;
    //chuyển paging bar về trang đầu
    if (grid && typeof grid.setPage === 'function') {
      grid.setPage(1);
    }

    //xóa tham số cũ để reload
    // delete me.lastParam;
    // me.refresh();
  }

  const gridEvent = {
    loadData: () => {},
    changePageSize: gridChangePageSize(), // dblclick: me.gridRowDbClick, //Món này event từ grid đã raise nhiều lần
    filter: reload(),
    //rowDbClick: me.onRowDbClick
  };

  return {
    gridInfo,
    gridEvent,
  };
};
